export default "__VITE_ASSET__DHBpadlc__"